<template>
  <div class="relative">
    <BaseIcon class="text-xl text-[#B3B3B3]" icon="angle-left" />

    <router-link
      class="absolute left-1/2 top-1/2 h-12 w-12 rounded-full opacity-50 -translate-x-1/2 -translate-y-1/2"
      :to="to"
    />
  </div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon.vue'

export default {
  name: 'BaseBackButton',

  components: { BaseIcon },

  props: {
    to: { type: Object, required: true }
  }
}
</script>
